module.exports = __webpack_public_path__ + "media/images/pic/green-pin-e2d2f7bad229636000f062d994650efd.svg";